<template>
    <b-modal id="bv-modal-email-contact" size="md" :title="isEditing ? 'Editar contato' : 'Adicionar novo contato'" scrollable centered no-stacking>
        <b-container fluid>
            <form id="email-contact-form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="contact-name">Nome <span class="text-danger">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                id="contact-name"
                                v-model="form.name"
                                placeholder="Nome do contato"
                            >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="contact-email">E-mail <span class="text-danger">*</span></label>
                            <input
                                type="email"
                                class="form-control"
                                id="contact-email"
                                v-model="form.contact"
                                placeholder="Ex: contato@email.com"
                            >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Grupos</label>
                            <div class="multiselect-container">
                                <input
                                    type="text"
                                    v-model="searchTerm"
                                    placeholder="Pesquisar grupos..."
                                    class="form-control mb-2"
                                >
                                <div class="checkbox-list">
                                    <div v-if="filteredGroups.length === 0" class="text-muted text-center py-2">
                                        Nenhum grupo encontrado.
                                    </div>
                                    <div v-for="group in filteredGroups" :key="group.id" class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :id="`group-${group.id}`"
                                            :value="group.id"
                                            v-model="form.groups"
                                        >
                                        <label class="form-check-label" :for="`group-${group.id}`">
                                            {{ group.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div v-if="selectedGroups.length > 0" class="badges-container">
                                <span
                                    v-for="group in selectedGroups"
                                    :key="group.id"
                                    class="badge badge-group"
                                >
                                    {{ group.name }}
                                    <span class="badge-remove" @click="removeGroup(group.id)" title="Remover">&times;</span>
                                </span>
                            </div>
                            <small v-else class="text-muted">Nenhum grupo selecionado.</small>
                        </div>
                    </div>
                </div>
            </form>
        </b-container>

        <template #modal-footer>
            <div class="modal-footer-wrapper">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>

                <button v-if="isEditing" type="button" @click.prevent="deleteContact" class="btn btn-danger" :disabled="loading">
                    <i class="fas fa-trash-alt"></i> Deletar
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "EmailContactModal",
    data() {
        return {
            loading: false,
            allGroups: [],
            dataEdit: {},
            searchTerm: '',
            form: {
                name: '',
                contact: '',
                groups: [],
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit.id;
        },
        filteredGroups() {
            if (!this.searchTerm) return this.allGroups;
            const term = this.searchTerm.toLowerCase();
            return this.allGroups.filter(g => g.name.toLowerCase().includes(term));
        },
        selectedGroups() {
            return this.allGroups.filter(g => this.form.groups.includes(g.id));
        },
    },
    methods: {
        async fetchGroups() {
            axios.get("/settings/contacts/groups/type/email").then(response => {
                this.allGroups = response.data.map(g => ({ id: g.id, name: g.name }));
            }).catch(error => {
                console.error(error);
                Swal.fire({ type: 'error', text: 'Falha ao carregar grupos!' });
            });
        },
        removeGroup(groupId) {
            this.form.groups = this.form.groups.filter(id => id !== groupId);
        },
        async openModal(data = null) {
            this.resetForm();
            await this.fetchGroups();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-email-contact');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit("updateContactTable", data);
            this.$bvModal.hide('bv-modal-email-contact');
        },
        loadFormData(data) {
            this.form.id      = data.id;
            this.form.name    = data.name;
            this.form.contact = data.contact;
            this.form.groups  = data.groups
                ? data.groups.map(g => (typeof g === 'object' ? g.id : g))
                : [];
        },
        resetForm() {
            this.form = {
                name: '',
                contact: '',
                groups: [],
            };
            this.searchTerm = '';
            this.dataEdit   = {};
        },
        validateForm() {
            if (!this.form.name || !this.form.name.trim()) {
                Swal.fire({ type: 'error', text: "Campo 'Nome' é obrigatório!" });
                return false;
            }
            if (!this.form.contact || !this.form.contact.trim()) {
                Swal.fire({ type: 'error', text: "Campo 'E-mail' é obrigatório!" });
                return false;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.form.contact)) {
                Swal.fire({ type: 'error', text: "E-mail inválido! Informe um endereço no formato usuario@dominio.com." });
                return false;
            }
            return true;
        },
        async deleteContact() {
            const { value } = await Swal.fire({
                title: 'Deseja deletar este contato?',
                text: 'Esta ação não poderá ser desfeita.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, deletar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#dc3545',
                reverseButtons: true,
                showCloseButton: true,
            });

            if (!value) return;

            this.loading = true;

            try {
                await axios.delete(`/settings/contacts/${this.form.id}`);
                Swal.fire({ type: 'success', text: 'Contato deletado com sucesso.' });
                this.$emit("deleteContact", this.form.id);
                this.closeModal();
            } catch (error) {
                console.error(error);
                const message = error.response?.data?.error || 'Falha ao deletar contato!';
                Swal.fire({ type: 'error', text: message });
                this.loading = false;
            }
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;

            const formData = {
                name:    this.form.name,
                contact: this.form.contact,
                type:    'email',
                groups:  this.form.groups,
            };

            try {
                let response;

                if (this.form.id) {
                    response = await axios.put(`/settings/contacts/${this.form.id}`, formData);
                    Swal.fire({ type: 'success', text: 'Contato atualizado com sucesso.' });
                } else {
                    response = await axios.post("/settings/contacts", formData);
                    Swal.fire({ type: 'success', text: 'Contato salvo com sucesso.' });
                }

                this.closeModal(response.data);
            } catch (error) {
                console.error(error);
                const message = error.response?.data?.error
                    ? Object.values(error.response.data.error).flat().join('\n')
                    : 'Falha ao salvar contato! Valide todos os campos e tente novamente.';
                Swal.fire({ type: 'error', text: message });
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>
.checkbox-list {
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 10px;
}

.badges-container {
    margin-top: 8px;
}

.badge-group {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 2px 4px;
    font-size: 0.85em;
    padding: 4px 8px;
    background-color: #dc3545;
    color: #ffffff;
}

.badge-remove {
    cursor: pointer;
    font-size: 1em;
    line-height: 1;
    opacity: 0.75;
}

.badge-remove:hover {
    opacity: 1;
}

.modal-footer-wrapper {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
}
</style>